import React from 'react';
import { IIconProps } from '../interfaces';

const ExclamationMark = (props: IIconProps) => {
    return (
        <svg
            className="max-w-full"
            xmlns="http://www.w3.org/2000/svg"
            width={ props.width }
            height={ props.height }
            fill="none"
            viewBox="0 0 2 11">
            { props.title && <title>{props.title}</title> }
            <path fill="#fff"
                  d="M1 0C.447 0 0 .307 0 .688v6.875c0 .38.447.688 1 .688.553 0 1-.307 1-.688V.688C2 .308 1.553 0 1 0ZM1 8.935c-.553 0-1 .308-1 .689v.688c0 .38.447.688 1 .688.553 0 1-.307 1-.688v-.688c0-.381-.447-.689-1-.689Z"/>
        </svg>
    )
};

export default ExclamationMark;